import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Stylesheet from './Forms.module.css';
import {user as AppUser} from '@enigma/core/services';
import Loading from '../../components/Spinner/Standard/Standard';
import { Link } from 'react-router-dom';
import Button from '../../elements/Button/Button';
import Table from '../../components/Table/Table';
import { UserContext } from '../../contexts/user';
import util from '@enigma/core/utilities';

const Forms = (props) => {
    const { name } = useParams();
    const [form, setForm] = useState(null);
    document.title = `Forms - ${name}`;
    useEffect(() => {
        new util.database('gmgroup.fleet').table('forms')
        .where('name', '==', name).get()
        .then(result => {
            if (result.empty) setForm(undefined);
            else {
                const table = result.getAll().pop();
                setForm(table.data)
            }
        })
    }, [name])

    if (form === null) return (
        <div className={Stylesheet.Container}>
            <div className={Stylesheet.Loading}>
                <Loading show />
            </div>
        </div>
    )
    if (form?.id === undefined) return (
        <div className={Stylesheet.Container}>
            <div className={Stylesheet.NotFound}>
                <h4>form '{name}' not found</h4>
                <h5>make sure the form was created before it is accesed</h5>
                <Button primary>
                <Link to='/settings/forms'>form settings</Link></Button>
            </div>
        </div>
    )
    return (
        <UserContext.Consumer>
            {user => (
                <div className={Stylesheet.Container}>
                    <Table 
                    metadata={form}
                    document={`forms/${form.id}`} 
                    addText='add form' 
                    toolbox
                    disableData
                    deleteText='remove form'
                    lock={!AppUser.isEmailVerified} 
                    schema={[{
                        title: "form", 
                        name: "name", 
                        type: "file", 
                        required: true, 
                        unique: false
                    },{
                        title: "comments", 
                        name: "comments", 
                        type: "string", 
                        required: true, 
                        unique: false
                    }]} />
                </div>
            )}
        </UserContext.Consumer>
    )
}

export default Forms;